import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sponsor-portal',
  templateUrl: './sponsor-portal.component.html',
  styleUrls: ['./sponsor-portal.component.scss']
})
export class SponsorPortalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
